module.exports = __webpack_public_path__ + "img/boc-logo.60ce5b14.png";